export const config = {
    clientId: import.meta.env.VITE_CLIENT_ID,
    authority_url: import.meta.env.VITE_AUTHORITY_URL,
    knownAuthority: import.meta.env.VITE_KNOWN_AUTHORITY,
    redirectUri: import.meta.env.VITE_REDIRECT_URL,
    postLogoutRedirectUri: import.meta.env.VITE_REDIRECT_URL,
    navigateToLoginRequestUrl: false,
    scopes: [import.meta.env.VITE_CLIENT_ID, "openid", "profile", "offline_access"],
    baseUrl: import.meta.env.VITE_SERVER_BASE_URL,
    pageSize: 20,
    dataLimitationPageSize: 50,
    inactivityTimeout: 30 * 60 * 1000,
    promptBeforeIdleTimeout: 15 * 60 * 1000,
};

